import moment from 'moment'

import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import colors from 'constants/colors'

import { Typography } from 'components'

import i18n from 'translations'

import { StyledSignaturePreviewContainer } from './SignaturePreviewStyled'

interface SignaturePreviewProps {
  signedAt: Date
  url: string
}

const SignaturePreview: React.FC<SignaturePreviewProps> = ({ signedAt, url }): JSX.Element => (
  <StyledSignaturePreviewContainer>
    <Typography padding="0 0 10px" variant="span">
      <Typography padding="0 10px 0" variant="span">
        {i18n.t('module:Injury:Preview:Signatures:Digital:signature')}
      </Typography>
      <Typography color={colors.gray} variant="span">
        {moment(signedAt).format('DD/MM/YYYY')}
      </Typography>
    </Typography>
    <LazyLoadImage
      alt="signature"
      effect="opacity"
      src={url}
    />
  </StyledSignaturePreviewContainer>
)

export default SignaturePreview
